import Vue from "vue"
import VueRouter from "vue-router"
import { Toast } from "vant"
import wechatAuth from '../assets/js/wechatAuth'
import { getOauth } from "../api/index.js";
import axios from "../assets/js/axios.js"
import {
  Dialog
} from "vant";

Vue.use(Toast)
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/components/page/index"),
    meta: {
      keepAlive: true,
      title: '首页'
    }
  },
  {
    path: "/biap",
    name: "biap",
    component: () => import("@/components/page/biap"),
    meta: {
      title: "biap购买引导",
    },
  },
  {
    path: "/biapHelp",
    name: "biapHelp",
    component: () => import("@/components/page/biapHelp"),
    meta: {
      title: "biap支付成功",
    },
  },
  {
    path: "/biapPay",
    name: "biapPay",
    component: () => import("@/components/page/biapPay"),
    meta: {
      title: "购买标讯分析会员",
    },
  },
  {
    path: "/biapAccount",
    name: "biapAccount",
    component: () => import("@/components/page/biapAccount"),
    meta: {
      title: "标讯分析账号详情",
    },
  },
  {
    path: "/list",
    name: "list",
    component: () => import("@/components/page/list"),
    meta: {
      title: "搜索结果",
    },
  },
  {
    path: "/purchaserAnalyse",
    name: "purchaserAnalyse",
    component: () => import("@/components/page/purchaserAnalyse"),
    meta: {
      title: "查采购人",
    },
  },
  {
    path: "/purchaserList",
    name: "purchaserList",
    component: () => import("@/components/page/purchaserAnalyse/list"),
    meta: {
      title: "采购人列表",
    },
  },
  {
    path: "/analyseDetail",
    name: "analyseDetail",
    component: () => import("@/components/page/purchaserAnalyse/analyseDetail"),
    meta: {
      title: "采购人报告",
    },
  },
  {
    path: "/analyseDetail1",
    name: "analyseDetail1",
    component: () => import("@/components/page/purchaserAnalyse/analyseDetail1"),
    meta: {
      title: "采购人报告",
    },
  },
  {
    path: "/buyAnalyse",
    name: "buyAnalyse",
    component: () => import("@/components/page/purchaserAnalyse/buyAnalyse"),
    meta: {
      title: "购买报告",
    },
  },
  {
    path: "/searchList",
    name: "searchList",
    component: () => import("@/components/page/searchList"),
    meta: {
      title: "查询列表",
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/components/page/login"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/subscribe",
    name: "subscribe",
    component: () => import("@/components/page/subscribe"),
    meta: {
      keepAlive: true,
      title: "推送列表",
    },
  },
  {
    path: "/addSubscribe",
    name: "addSubscribe",
    component: () => import("@/components/page/addSubscribe"),
    meta: {
      title: "添加订阅",
    },
  },
  {
    path: "/subscribeList",
    name: "subscribeList",
    component: () => import("@/components/page/subscribeList"),
    meta: {
      title: "订阅列表",
    },
  },
  {
    path: "/collectList",
    name: "collectList",
    component: () => import("@/components/page/collectList"),
    meta: {
      title: "收藏列表",
    },
  },
  {
    path: "/report",
    name: "report",
    component: () => import("@/components/page/report"),
  },
  {
    path: "/help",
    name: "help",
    component: () => import("@/components/page/help"),
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("@/components/page/detail"),
    meta: {
      title: "公告详情",
    },
  },
  {
    path: "/export",
    name: "export",
    component: () => import("@/components/page/export"),
    meta: {
      title: "数据导出",
    },
  },
  {
    path: "/my",
    name: "my",
    component: () => import("@/components/page/my"),
    meta: {
      title: "我的",
    },
  },
  {
    path: "/agent",
    name: "agent",
    component: () => import("@/components/page/my/agent"),
    meta: {
      title: "代理商",
    },
  },
  {
    path: "/toAgent",
    name: "toAgent",
    component: () => import("@/components/page/my/toAgent"),
    meta: {
      title: "成为代理商",
    },
  },
  {
    path: "/codeExchange",
    name: "codeExchange",
    component: () => import("@/components/page/my/codeExchange"),
    meta: {
      title: "邀请码",
    },
  },
  {
    path: "/setpass",
    name: "setpass",
    component: () => import("@/components/page/setpass"),
    meta: {
      title: "修改密码",
    },
  },
  {
    path: "/myorder",
    name: "myOrder",
    component: () => import("@/components/page/myorder"),
    meta: {
      title: "我的订单",
    },
  },
  {
    path: "/orderDetail",
    name: "orderDetail",
    component: () => import("@/components/page/myorder/orderDetail"),
    meta: {
      title: "订单详情",
    },
  },
  {
    path: "/mymember",
    name: "myMember",
    component: () => import("@/components/page/mymember"),
    meta: {
      title: "我的会员",
    },
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/components/page/search"),
    meta: {
      title: "查询",
    },
  },
  {
    path: "/FreeSubscribe",
    name: "FreeSubscribe",
    component: () => import("@/components/page/FreeSubscribe"),
    meta: {
      title: "添加免费订阅",
    },
  },
  {
    path: "/VipSubscribe",
    name: "VipSubscribe",
    component: () => import("@/components/page/VipSubscribe"),
    meta: {
      title: "添加vip免费订阅",
    },

  },
  {
    path: "/buyVip",
    name: "buyVip",
    component: () => import("@/components/page/buyVip"),
    meta: {
      title: "购买推送会员",
    },
  },
  {
    path: "/toPay",
    name: "toPay",
    component: () => import("@/components/page/toPay"),
    meta: {
      title: "支付",
    },
  },
]


let accountType = localStorage.getItem("account_type") || 0
let mobile = localStorage.getItem("mobile") || ''

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

//截取code
function getCode() {
  let url = location.search;
  let code = "";

  let localOpenId = localStorage.getItem('openId') == "" || localStorage.getItem('openId') == null
  console.log('localOpenId',localOpenId)
  if (localOpenId && url.indexOf("?") != -1) {
    var split = url.split("?code=")
    code = split[1].split("&")[0]
  }
  return code;
}

// 获取sign
function getSign(next) {

  
  let theCode = getCode();
  let isOpenId = localStorage.getItem("openId") == null || localStorage.getItem("openId") == ""
  console.log('theCode', theCode)
  if (theCode) {
    console.log('进入getSign - theCode--------------------')
    var formData = new FormData();
    formData.append("code", theCode);
    axios({
      method: "post",
      url: "/bid_news/oauth",
      data: { code: theCode }
    }).then(res => {
      if (res.data.status_code == 0) {
        // localStorage.setItem("wx_sign", res.data.data.sign);
        localStorage.setItem("openId", res.data.data.openid);
        localStorage.setItem("nickname", res.data.data.nickname);
        localStorage.setItem("headimgurl", res.data.data.headimgurl);
        let realUrl = window.location.href.split("?")[0];
        window.location.href = realUrl;
        next()
      } else {
        Dialog.alert({
          title: '提示',
          message: res.data.status_msg,
        }).then(() => {
          WeixinJSBridge.call('closeWindow')
        })
      }
    });
  }
  // else if (isOpenId) {
  //   console.log('进入getSign - isOpenId--------------------')
  //   if (process.env.NODE_ENV === 'development') {
  //     // 在开发环境下的逻辑处理
  //   } else if (process.env.NODE_ENV === 'production') {
  //     // 在线上环境下的逻辑处理
     
  //   }
  // }
  else {
    console.log('进入getSign - next--------------------')
    next()
  }
}


// // 获取
function checkLogin(to, next) {
  axios({
    method: "post",
    url: "/bid_news/official_account/checklogin",
    data: { mobile: localStorage.getItem('mobile') }
  }).then(res => {
    if (res.data.status_code == 0) {
      if (res.data.status_msg == '此账号未查询到') {
        localStorage.setItem("power_province", []);
        localStorage.setItem("power_industry", []);
      } 
      else {
        localStorage.setItem("openId", res.data.data.openid);
        localStorage.setItem("nickname", res.data.data.nickname);
        localStorage.setItem("headimgurl", res.data.data.headimgurl);
        localStorage.setItem("phone", res.data.data.contact_info);
        localStorage.setItem("mobile", res.data.data.contact_info);
        localStorage.setItem("account_type", res.data.data.account_type);
        localStorage.setItem("referral_code", res.data.data.referral_code);
        getPowerList()

      }
      // localStorage.setItem("wx_sign", res.data.data.sign);
      let mobile = res.data.data.contact_info
      let mobileLength = mobile == null ? 0 : mobile.length
      console.log('----', mobileLength)
      // if (mobileLength == 0){
      //   // next('/login')
      // } 
      // else{
      //   next()
      // }
    }
    else {
      // if(to.name!='login' ){
      //   next('/login')
      // }
    }
  });
}
function getPowerList() {
  axios({
    method: "post",
    url: "/bid_news/official_account/bnauth",
    data: { mobile: localStorage.getItem('mobile') }
  }).then(res => {
    if (res.data.status_code == 0) {
      localStorage.setItem("power_province", JSON.stringify(res.data.data?.power_list[0]?.province));
      localStorage.setItem("power_industry", JSON.stringify(res.data.data?.power_list[0]?.industry));
      localStorage.setItem("userInfo", JSON.stringify(res.data.data));
      localStorage.setItem("referral_code", res.data.data.referral_code);

    }
    else {
      console.log('----', res.data.status_msg)
    }
  });
}
router.beforeEach((to, from, next) => {
  console.log(to);
  console.log(to, from, next);
  let arr = ['index', 'buyVip']
  document.title = to.meta.title || '实时标讯'
  let isToPath = to.path != '/biapPay' && to.path != '/'
  if (isToPath && from.path == '/biap') {

    localStorage.setItem('biapPayPath', '1')
    next()
  } else {
    next()
  }
  let isSavePath = from.path == '/login' && to.path != 'login'
  console.log('isSavePath', from.path)
  console.log('isSavePath', to.path)
  console.log('isSavePath', isSavePath)
  if (isSavePath) {
    localStorage.setItem('SavePath', to.path)
  }
  getSign(next)
  checkLogin(to, next)
  if (to.path === "/subscribe" || to.path === "/collectList") {
    if (
      localStorage.getItem("phone") &&
      localStorage.getItem("isOfficial") == "true"
    ) {
      sessionStorage.removeItem("active")
      sessionStorage.setItem("active", 1)
      next()
    }
  }
  else {
    if (to.path === "/") {
      sessionStorage.removeItem("active")
      sessionStorage.setItem("active", 0)
    } else if (to.path === "/my") {
      sessionStorage.removeItem("active")
      sessionStorage.setItem("active", 2)
      // sessionStorage.setItem("active", 3)
    }
    next()
  }
})

export default router
